import {
  exists,
  SystemCode,
  SystemCodeFromJSON,
  defaultSystemCode
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface CollectionListBibliographyInfo {
  id: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  collectionFlag: CollectionFlag
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  displayClass: string
  displaySize: string
  displayMaterialFormat: SystemCode
  displayPublished: string
  isbn10: string
  isbn13: string
}

export function CollectionListBibliographyInfoFromJSON(
  json: any
): CollectionListBibliographyInfo {
  return {
    id: exists(json, 'id') ? json.id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    displaySize: exists(json, 'display_size') ? json.display_size : '',
    displayMaterialFormat: exists(json, 'display_material_format')
      ? SystemCodeFromJSON(json.display_material_format)
      : defaultSystemCode(),
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    isbn10: exists(json, 'isbn10') ? json.isbn10 : '',
    isbn13: exists(json, 'isbn13') ? json.isbn13 : ''
  }
}
